<template>
  <el-tooltip
    :effect="effect"
    :content="content"
    :placement="placement"
  >
    <sino-button
      class="tooltip-button"
      :icon="icon"
      type="text"
      @click="btnClick"
    />
  </el-tooltip>
</template>

<script>
import sinoButton from "./sinoButton";
export default {
  name: "tooltip-button",
  components: {
    sinoButton,
  },
  props: {
    effect: {
      type: String,
      default: "dark",
    },
    content: {
      type: String,
      default: "按钮名称",
    },
    placement: {
      type: String,
      default: "top",
    },
    icon: {
      type: String,
      default: "top",
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    btnClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-button {
  padding: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  &:hover {
    background: #eff4f9;
  }
}
</style>
